<template>
  <detail-template :classCustom="'detail-docs'">
    <template #content>
      <div
        class="back-icon border-radius__50 clickable flex-row flex__center"
        @click="backListPage()"
      >
        <i class="el-icon-back font-size__large"></i>
      </div>

      <div class="header">
        <div class="docTags">
          <hc-dieuxe-state
            v-if="hcFlowInstance"
            :state="hcFlowInstance.currentStateCode"
          />
        </div>
      </div>

      <VuePerfectScrollbar class="scroll-area">
        <div class="body">
          <div
            style="color: #007aff"
            class="font-size__large font-weight__bold margin-top-10 margin-bottom-10"
          >
            Yêu cầu đăng ký điều xe
          </div>
          <div class="margin-top-10" v-if="!!requestUserDeptRole">
            <span class="label-input">Đơn vị yêu cầu:</span>
            <span class="font-weight__bold">{{
              requestUserDeptRole.deptName
            }}</span>
          </div>
          <div
            class="margin-top-10 padding-bottom-10 flex-row has-border__bottom"
            v-if="hcCaseDieuxe && requestUserDeptRole"
          >
            <span class="label-input">Người yêu cầu:</span>
            <div class="flex-row flex__left margin-left-10">
              <span class="font-weight__bold">{{
                requestUserDeptRole.fullName
              }}</span>
            </div>
            <span class="label-input margin-left-10">vào lúc:</span>
            <div class="flex-row flex__left margin-left-10">
              <span class="font-weight__bold">
                {{
                  hcCaseDieuxe.createTime | dateFormatter({ nullValue: "-" })
                }}
              </span>
            </div>
          </div>

          <el-form
            ref="form"
            :model="form"
            :rules="rules"
            inline-message
            label-width="150px"
          >
            <div class="group__info margin-top-10">
              <div class="content">
                <div class="form-input">
                  <div
                    class="title font-size__small font-weight__bold margin-bottom-10"
                  >
                    Thông tin yêu cầu
                  </div>

                  <el-form-item
                    label="Loại yêu cầu"
                    prop="requestType"
                    class="custom-label__input width25"
                  >
                    <el-select
                      class="input-border__bottom input-border__radius__0 style-fullWidth input-font__bold "
                      v-model="form.requestType"
                      placeholder="Loại yêu cầu"
                      size="medium"
                      filterable
                      clearable
                      :disabled="true"
                    >
                      <el-option
                        v-for="item in requestTypes"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="Tiêu đề" prop="title">
                    <el-input
                      type="textarea"
                      v-model="form.title"
                      placeholder="Tiêu đề"
                      class="input-border__bottom input-border__radius__0 style-fullWidth input-font__bold input-count__bottom"
                      size="medium"
                      maxlength="2000"
                      show-word-limit
                      :autosize="{ minRows: 2, maxRows: 5 }"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Nội dung yêu cầu" prop="title">
                    <el-input
                      type="textarea"
                      v-model="form.content"
                      placeholder="Nội dung yêu cầu"
                      class="input-border__bottom input-border__radius__0 style-fullWidth input-font__bold input-count__bottom"
                      size="medium"
                      maxlength="5000"
                      show-word-limit
                      :autosize="{ minRows: 3, maxRows: 5 }"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Số người đi" prop="numberOfPeople">
                    <el-input
                      size="medium"
                      class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                      v-model="form.numberOfPeople"
                      placeholder="Số người đi"
                      :controls="false"
                      :min="0"
                      :step="1"
                      :precision="0"
                      :max="100"
                      :readonly="true"
                    >
                    </el-input>
                  </el-form-item>

                  <el-form-item
                    label="Số điện thoại liên hệ"
                    prop="contactNumber"
                  >
                    <el-input
                      class="input-border__bottom input-border__radius__0 style-fullWidth input-font__bold input-count__bottom"
                      v-model="form.contactNumber"
                      size="medium"
                      placeholder="Số điện thoại liên hệ"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Địa điểm đi" prop="fromPlace">
                    <el-input
                      v-model="form.fromPlace"
                      placeholder="Địa điểm đi"
                      type="textarea"
                      class="input-border__bottom input-border__radius__0 style-fullWidth input-font__bold input-count__bottom"
                      size="medium"
                      maxlength="1000"
                      show-word-limit
                      :autosize="{ minRows: 3, maxRows: 5 }"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Địa điểm đến" prop="toPlace">
                    <el-input
                      placeholder="Địa điểm đến"
                      v-model="form.toPlace"
                      type="textarea"
                      class="input-border__bottom input-border__radius__0 style-fullWidth input-font__bold input-count__bottom"
                      size="medium"
                      maxlength="1000"
                      show-word-limit
                      :autosize="{ minRows: 3, maxRows: 5 }"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Thời gian đi" prop="startTime">
                    <el-date-picker
                      v-model="form.startTime"
                      size="medium"
                      class="input-border__bottom input-border__radius__0 style-fullWidth input-font__bold"
                      type="datetime"
                      placeholder="dd/MM/yyyy HH:mm"
                      format="dd/MM/yyyy HH:mm"
                      :prefix-icon="' '"
                      :readonly="true"
                    >
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item label="Thời gian về" prop="endTime">
                    <el-date-picker
                      v-model="form.endTime"
                      size="medium"
                      class="input-border__bottom input-border__radius__0 style-fullWidth input-font__bold"
                      type="datetime"
                      placeholder="dd/MM/yyyy HH:mm"
                      format="dd/MM/yyyy HH:mm"
                      :prefix-icon="' '"
                      :readonly="true"
                    >
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item label="Ghi chú" prop="note" v-if="!!form.note">
                    <el-input
                      type="textarea"
                      v-model="form.note"
                      placeholder="Ghi chú"
                      class="input-border__bottom input-border__radius__0 style-fullWidth input-font__bold"
                      size="medium"
                      maxlength="2000"
                      show-word-limit
                      :autosize="{ minRows: 2, maxRows: 5 }"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>

            <hc-dieuxe-cars-and-drivers-readonly :hcCaseMasterId="caseMasterId">
            </hc-dieuxe-cars-and-drivers-readonly>
          </el-form>
        </div>
      </VuePerfectScrollbar>

      <div
        class="footer"
        v-if="
          isAbleToCapNhat || isAbleToHuy || isAbleToPheDuyet || isAbleToTuChoi
        "
      >
        <div class="flex-row flex__between">
          <div class="flex-row flex__left form-button__action">
            <el-button
              size="medium"
              class="addDocs color__white bg__blue btn-none__border"
              v-if="isAbleToCapNhat"
              @click="update"
            >
              <i class="font-size__small fas fa-pencil-alt"></i>
              &nbsp;Cập nhật
            </el-button>

            <el-button
              size="medium"
              class="addDocs color__white bg__blue btn-none__border"
              v-if="isAbleToPheDuyet"
              @click="approve"
            >
              <i class="font-size__small fas fa-pencil-alt"></i>
              &nbsp;Phê duyệt
            </el-button>

            <el-button
              size="medium"
              class="addDocs color__white bg__blue btn-none__border"
              v-if="isAbleToTuChoi"
              @click="reject"
            >
              <i class="font-size__small fas fa-pencil-alt"></i>
              &nbsp;Từ chối
            </el-button>

            <el-button
              size="medium"
              class="addDocs color__white bg__blue btn-none__border"
              v-if="isAbleToHuy"
              @click="cancel"
            >
              <i class="font-size__small fas fa-pencil-alt"></i>
              &nbsp;Hủy
            </el-button>
          </div>
        </div>
      </div>

      <hc-dieuxe-approve-dialog
        v-if="!!hcCaseDieuxe && isEnableDialogApprove"
        :isOpen="isOpenDialogApprove"
        :id="hcCaseDieuxe.id"
        @dialogClosed="isEnableDialogApprove = false"
        @closeDialog="isOpenDialogApprove = false"
        @approveSuccess="approveSuccess"
      />

      <hc-dieuxe-update-dialog
        v-if="!!hcCaseDieuxe && isEnableDialogUpdate"
        :isOpen="isOpenDialogUpdate"
        :id="hcCaseDieuxe.id"
        @dialogClosed="isEnableDialogUpdate = false"
        @closeDialog="isOpenDialogUpdate = false"
        @updateSuccess="updateSuccess"
      />

      <hc-dieuxe-tu-choi-dialog
        v-if="!!hcCaseDieuxe && isEnableDialogReject"
        :isOpen="isOpenDialogReject"
        :id="hcCaseDieuxe.id"
        @dialogClosed="isEnableDialogReject = false"
        @closeDialog="isOpenDialogReject = false"
        @rejectSuccess="rejectSuccess"
      />

      <hc-dieuxe-huy-dialog
        v-if="!!hcCaseDieuxe && isEnableDialogCancel"
        :isOpen="isOpenDialogCancel"
        :id="hcCaseDieuxe.id"
        @dialogClosed="isEnableDialogCancel = false"
        @closeDialog="isOpenDialogCancel = false"
        @cancelSuccess="cancelSuccess"
      />
    </template>
  </detail-template>
</template>

<script>
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import dateFormatter from "../../../filters/dateFormatter";
  import hanhchinhService from "../../../services/hanhchinhService";
  import {EventBus} from "../../../event-bus.js";
  import handleRequestErrorMixin from "../../handleRequestErrorMixin";
  import HcDieuxeState from "./hc-dieuxe-state";
  import hcCaseDieuXeService from "../../../services/hcCaseDieuXeService";
  import hcCaseMasterService from "../../../services/hcCaseMasterService";
  import hcFlowInstanceService from "../../../services/hcFlowInstanceService";
  import hcStateToStateService from "../../../services/hcStateToStateService";
  import goBackMixin from "../../../mixins/goBackMixin";
  import hanhChinhUtils from "../../../services/hanhChinhUtils";
  import constants from "../../../constants";
  import h from "../../../services/h";
  import HcDieuxeApproveDialog from "./hc-dieuxe-approve-dialog";
  import HcDieuxeCarsAndDriversReadonly from "./hc-dieuxe-cars-and-drivers-readonly";
  import HcDieuxeTuChoiDialog from "./hc-dieuxe-tu-choi-dialog";
  import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
  import HcDieuxeHuyDialog from "./hc-dieuxe-huy-dialog";
  import HcDieuxeUpdateDialog from "./hc-dieuxe-update-dialog";

  export default {
    name: "hc-dieuxe-detail",
    mixins: [handleRequestErrorMixin, goBackMixin],
    filters: {dateFormatter},
    components: {
      HcDieuxeUpdateDialog,
      HcDieuxeHuyDialog,
      HcDieuxeTuChoiDialog,
      HcDieuxeCarsAndDriversReadonly,
      HcDieuxeApproveDialog,
      HcDieuxeState,
      VuePerfectScrollbar,
      detailTemplate: () => import("../../common/detail.vue"),
      Multiselect: () => import("vue-multiselect")
    },

    data() {
      return {
        hcCaseDieuxe: null,
        hcFlowInstance: null,
        hcCaseMaster: null,
        nextHcStateToStateActions: null,
        requestUserDeptRole: null,
        form: {
          requestType: null,
          title: null,
          content: null,
          numberOfPeople: 1,
          contactNumber: null,
          fromPlace: null,
          toPlace: null,
          startTime: null,
          endTime: null
        },
        rules: {
          title: null,
          content: null,
          numberOfPeople: null,
          fromPlace: null,
          toPlace: null,
          startTime: null,
          endTime: null
        },
        requestTypes: [],

        isAbleToCapNhat: false,
        isAbleToHuy: false,
        isAbleToPheDuyet: false,
        isAbleToTuChoi: false,

        isOpenDialogApprove: false,
        isEnableDialogApprove: false,
        isOpenDialogReject: false,
        isEnableDialogReject: false,
        isOpenDialogCancel: false,
        isEnableDialogCancel: false,
        isOpenDialogUpdate: false,
        isEnableDialogUpdate: false
      };
    },

    computed: {
      caseMasterId() {
        return this.$route.params.id;
      },
      userDeptRole() {
        return this.$store.getters.userDeptRole;
      },
      isRequester() {
        return hanhChinhUtils.isRequester(this.userDeptRole, this.hcCaseDieuxe);
      },
      isApprover() {
        return (
          this.userDeptRole &&
          this.userDeptRole.roleCode === constants.ROLE.CODE.DIEU_XE.QUAN_LY_XE
        );
      }
    },

    watch: {
      caseMasterId() {
        this.reloadPage();
      },

      isOpenDialogApprove(newValue) {
        if (newValue) this.isEnableDialogApprove = newValue;
      },

      isOpenDialogReject(newValue) {
        if (newValue) this.isEnableDialogReject = newValue;
      },

      isOpenDialogCancel(newValue) {
        if (newValue) this.isEnableDialogCancel = newValue;
      },

      isOpenDialogUpdate(newValue) {
        if (newValue) this.isEnableDialogUpdate = newValue;
      }
    },

    created() {
      this.initSelectOptions();
      this.initPage();
    },

    methods: {
      afterSubmitSuccess() {
        this.notifyMasterForDataChange({});
        this.goBack();
      },

      update() {
        this.isOpenDialogUpdate = true;
      },

      updateSuccess() {
        this.isOpenDialogUpdate = false;
        this.afterSubmitSuccess();
      },

      loadRequestUserDeptRole() {
        return userDeptRoleViewService
          .findRequesterForHc(this.caseMasterId)
          .then(response => (this.requestUserDeptRole = response.data));
      },

      cancel() {
        this.isOpenDialogCancel = true;
      },

      cancelSuccess() {
        this.isOpenDialogCancel = false;
        this.afterSubmitSuccess();
      },

      rejectSuccess() {
        this.isOpenDialogReject = false;
        this.afterSubmitSuccess();
      },

      reject() {
        this.isOpenDialogReject = true;
      },

      approve() {
        this.isOpenDialogApprove = true;
      },

      approveSuccess() {
        this.isOpenDialogApprove = false;
        this.afterSubmitSuccess();
      },

      async reloadPage() {
        await this.initPage();
      },

      convertToSubmitForm() {
        return {
          flowId: this.flowId,
          requestType: this.form.requestType,
          title: this.form.title,
          content: this.form.content,
          numberOfPeople: this.form.numberOfPeople,
          contactNumber: this.form.contactNumber,
          fromPlace: this.form.fromPlace,
          toPlace: this.form.toPlace,
          startTime: this.form.startTime.getTime(),
          endTime: this.form.endTime.getTime()
        };
      },

      initSelectOptions() {
        this.requestTypes = hanhChinhUtils.buildDieuXeRequestTypeOptions();
      },

      async initPage() {
        await this.loadHcCaseDieuXe();
        await this.loadHcCaseMaster();
        await this.loadHcFlowInstance();
        await this.loadNextActions();
        await this.loadRequestUserDeptRole();
        this.initActions();
        this.initFormForEdit();
      },

      initFormForEdit() {
        this.bindDataToForm(this.form);
      },

      bindDataToForm(form) {
        form.requestType = this.hcCaseDieuxe.requestType;
        form.title = this.hcCaseDieuxe.title;
        form.content = this.hcCaseDieuxe.description;
        form.numberOfPeople = this.hcCaseDieuxe.numberOfPeople;
        form.contactNumber = this.hcCaseDieuxe.contactNumber;
        form.fromPlace = this.hcCaseDieuxe.fromPlace;
        form.toPlace = this.hcCaseDieuxe.toPlace;
        form.startTime = this.hcCaseDieuxe.startTime
          ? new Date(this.hcCaseDieuxe.startTime)
          : null;
        form.endTime = this.hcCaseDieuxe.endTime
          ? new Date(this.hcCaseDieuxe.endTime)
          : null;
        form.note = this.hcCaseDieuxe.note;
      },

      initActions() {
        this.isAbleToCapNhat =
          this.isEnableAction(
            constants.HC_STATE_TO_STATE.ACTION_CODE.DIEU_XE.CAP_NHAT
          ) &&
          ((this.hcFlowInstance.currentStateCode ===
            constants.HC_STATE.STATE_CODE.DIEU_XE.CHO_PHE_DUYET &&
            this.isRequester) ||
            (this.hcFlowInstance.currentStateCode ===
              constants.HC_STATE.STATE_CODE.DIEU_XE.DA_PHE_DUYET &&
              this.isApprover));

        this.isAbleToHuy = this.isEnableAction(
          constants.HC_STATE_TO_STATE.ACTION_CODE.DIEU_XE.HUY_YEU_CAU
        );
        // && this.userDeptRole.userId === this.hcCaseDieuxe.requestUserId;
        this.isAbleToPheDuyet = this.isEnableAction(
          constants.HC_STATE_TO_STATE.ACTION_CODE.DIEU_XE.PHE_DUYET
        );
        this.isAbleToTuChoi = this.isEnableAction(
          constants.HC_STATE_TO_STATE.ACTION_CODE.DIEU_XE.TU_CHOI
        );
      },

      isEnableAction(actionCode) {
        return h.exists(
          this.nextHcStateToStateActions,
          hcStateToState => hcStateToState.actionCode === actionCode
        );
      },

      loadNextActions() {
        return hcStateToStateService
          .findAllActionsByHcCaseCommands(this.hcCaseMaster.flowInstanceId)
          .then(response => (this.nextHcStateToStateActions = response.data));
      },

      loadHcFlowInstance() {
        return hcFlowInstanceService
          .findById(this.hcCaseMaster.flowInstanceId)
          .then(response => (this.hcFlowInstance = response.data));
      },

      loadHcCaseMaster() {
        return hcCaseMasterService
          .findById(this.hcCaseDieuxe.hcCaseMasterId)
          .then(response => (this.hcCaseMaster = response.data));
      },

      loadHcCaseDieuXe() {
        return hcCaseDieuXeService
          .findByHcCaseMaster(this.caseMasterId)
          .then(response => (this.hcCaseDieuxe = response.data));
      },

      backListPage() {
        this.goBack();
      },

      cancelRequest() {
        if (!this.note) {
          return this.notify("Lỗi", "Vui lòng nhập ghi chú", "error", 2000);
        }

        let submitForm = {
          caseMasterId: this.caseMasterId,
          note: this.note
        };

        this.$confirm("Bạn có muốn hủy yêu cầu đăng ký này?", {
          confirmButtonText: "Xác nhận",
          cancelButtonText: "Hủy bỏ",
          type: "warning"
        }).then(() => {
          hanhchinhService
            .cancelCar(submitForm)
            .then(() => {
              this.notify("Thông báo", "Hủy yêu cầu thành công", "success", 2000);
              EventBus.$emit("eventCalled", {});
              this.backListPage();
            })
            .catch(error => this.commonHandleRequestError(error));
        });
      }
    }
  };
</script>

<style scoped>
  .error {
    color: #f56c6c;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    margin-left: 10px;
  }

  .tableHeader {
    height: 35px;
  }

  tr {
    text-align: center;
  }

  th {
    font-size: 13px;
    color: black;
    border-bottom: 1px solid #e3e8ee;
  }

  table {
    border: 1px solid #e3e8ee;
    border-radius: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/views/adminstration/dieuxe/hc-dieuxe-detail.vue